<div class="limiter  animated fadeInRight">
    <div class="container-login100">
        <div class="wrap-login100 p-t-50 p-b-90">
            <form (ngSubmit)="onSubmit( fVariable )" #fVariable="ngForm"
                class="login100-form validate-form flex-sb flex-w">

                <span class="login100-form-title p-b-51 main-color">
                    Crear nueva cuenta
                </span>

                <span *ngIf="fVariable.submitted && fVariable.controls['nombre'].errors"
                    class="text-danger animated fadeIn">El nombre(s) es obligatorio</span>
                <div class="wrap-input100 m-b-16">
                    <input class="input100" type="text" name="nombre" [(ngModel)]="usuario.nombres" 
                    required 
                    placeholder="Nombre(s)">
                    <span class="focus-input100"></span>
                </div>

                <span *ngIf="fVariable.submitted && fVariable.controls['apellidos'].errors"
                    class="text-danger animated fadeIn">Los apellidos son obligatorios</span>
                <div class="wrap-input100 m-b-16">
                    <input class="input100" type="text" name="apellidos" [(ngModel)]="usuario.apellidos" 
                    required 
                    placeholder="Apellidos">
                    <span class="focus-input100"></span>
                </div>

                <span *ngIf="fVariable.submitted && fVariable.controls['email'].errors"
                    class="text-danger animated fadeIn">El correo es obligatorio</span>
                <div class="wrap-input100 m-b-16">
                    <input class="input100" type="email" name="email" [(ngModel)]="usuario.email" required email
                    placeholder="Email">

                    <span class="focus-input100"></span>
                </div>

                <span *ngIf="fVariable.submitted && fVariable.controls['colegio'].errors"
                    class="text-danger animated fadeIn">El colegio es obligatorio, datos ficticios sería meritorios de eliminar la cuenta.</span>
                <div class="wrap-input100 m-b-16">
                    <input class="input100" type="text" name="colegio" [(ngModel)]="usuario.colegio" 
                    required 
                    placeholder="colegio">
                    <span class="focus-input100"></span>
                </div>

                <!-- <span *ngIf="fVariable.submitted && fVariable.controls['password'].errors" 
                    class="text-danger animated fadeIn">Al menos 6 carácteres</span>
                <div class="wrap-input100 m-b-16"    
                    data-validate="Password is required" 
                    style="display: none;">
                    <input class="input100" 
                    type="password" 
                    name="pass" 
                    [(ngModel)]="usuario.password"
                    placeholder="Password"
                    value="123456">
                    <span class="focus-input100"></span>
                </div> -->

                <div class="form-field" >
                    <label for="edades">Rango de edad:</label>
                    <select class=" wrap-input100 m-b-16" 
                        required 
                        name="edades" 
                        [(ngModel)]="usuario.edades" 
                        placeholder="selecciona">
                        <option value="edad1">de 20 a 30</option>
                        <option value="edad2">de 31 a 40</option>
                        <option value="edad3" selected>de 41 a 50</option>
                        <option value="edad4">de 51 o más</option>
                    </select>
                </div>

                <div class="form-field">
                    <label for="cars">Rol que desempeña:</label>
                    <select class="wrap-input100 m-b-16"
                        required  
                        name="puesto" 
                        [(ngModel)]="usuario.puesto" 
                        placeholder="selecciona">
                        <option value="puesto1">Director(a)</option>
                        <option value="puesto2" selected>Docente</option>
                        <option value="puesto3">Coordinador(a) académico</option>
                        <option value="puesto4">Madre o padre de familia</option>
                    </select>
                </div>

                <div class="flex-sb-m w-full p-t-3 p-b-24">
                    <div class="contact100-form-checkbox">
                        <input [(ngModel)]="aceptoTerm" class="input-checkbox100" id="ckb2" type="checkbox"
                        name="aceptoTerm" >
                        <label class="label-checkbox100" for="ckb2">
                            &nbsp;
                        </label>
                    </div>

                    <div>
                        Al incribirse, se acepta el
                        <a routerLink="/legales" class="simple-link">
                            Aviso de privacidad
                        </a>
                    </div>
                    <!-- <div class=" ">
                        <span>
                            <input [(ngModel)]="aceptoTerm" class="input-checkbox100" id="ckb1" type="checkbox"
                            name="aceptoTerm" >
                        Al incribirse, se acepta el <a routerLink="/legales" class="simple-link">Aviso de privacidad</a>.</span>
                    </div>-->
                </div>


                <div class="flex-sb-m w-full p-t-3 p-b-24">
                    <div class="contact100-form-checkbox">
                        <input [(ngModel)]="recordarme" class="input-checkbox100" id="ckb1" type="checkbox"
                        name="remember-me" >
                        <label class="label-checkbox100" for="ckb1">
                            Recordar mi usuario
                        </label>
                    </div>

                    <div>
                        <a routerLink="/login" class="simple-link">
                            ¿Ya tienes cuenta? / Ingresar
                        </a>
                    </div>
                </div>

                <div class="container-login100-form-btn m-t-17">
                    <button class="btn-big" type="submit">
                        Inscribirse
                    </button>
                </div>

            </form>
        </div>
    </div>
</div>